// extracted by mini-css-extract-plugin
export default {"icon":"iconStyles__icon--j_WENhLQ_LKcin31LoQ3"};